const isPromiseRejected = (input: PromiseSettledResult<unknown>): input is PromiseRejectedResult =>
    input.status === "rejected";

const isPromiseFulfilled = <T>(input: PromiseSettledResult<T>): input is PromiseFulfilledResult<T> =>
    input.status === "fulfilled";

export {
    isPromiseFulfilled,
    isPromiseRejected,
};